module.exports = __webpack_public_path__ + "img/studying.c511e4ac.svg";